import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  CardActions,
  Button,
  Box,
  Avatar,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config";
import { useAuth } from "../Context/AuthContext";
import { formatDistanceToNow } from "date-fns";
import API_BASE_URL from "../../utils/api";

const ViewDrafts = ({ onEditDraft }) => {
  const [drafts, setDrafts] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    axios
      .get(`${API_BASE_URL}/threads?drafts=true&userId=${user._id}`)
      .then((res) => setDrafts(res.data.threads))
      .catch((err) => console.error(err));
  }, [user]);

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        My Drafts
      </Typography>
      {drafts.map((thread) => (
        <Box
          key={thread._id}
          sx={{ mb: 2, p: 2, border: "1px solid #ddd", borderRadius: 2 }}
        >
          <Box display="flex" alignItems="center" mb={1}>
            <Avatar
              src={thread.author?.profileImage}
              alt={thread.author?.name}
              sx={{ mr: 1 }}
            />
            <Typography variant="subtitle2">{thread.author?.name}</Typography>
            <Typography variant="caption" sx={{ ml: 1, color: "gray" }}>
              {formatDistanceToNow(new Date(thread.createdAt), {
                addSuffix: true,
              })}
            </Typography>
          </Box>
          <Typography variant="h6">{thread.title}</Typography>
          <Typography variant="body2" color="text.secondary">
            {thread.content.length > 100
              ? thread.content.slice(0, 100) + "..."
              : thread.content}
          </Typography>
          <CardActions>
            <Button size="small" onClick={() => onEditDraft(thread)}>
              Edit/View
            </Button>
          </CardActions>
        </Box>
      ))}
    </Box>
  );
};

export default ViewDrafts;
